const REACT_APP_SBMA_ADMIN_API_ENDPOINT = process.env.REACT_APP_EID_ADMIN_API_ENDPOINT;
const ADMIN_PROFILE_BASE_URL = REACT_APP_SBMA_ADMIN_API_ENDPOINT + "/api/v1/profile";
const ADMIN_PROFILE_USER_BASE_URL = REACT_APP_SBMA_ADMIN_API_ENDPOINT + "/api/v1/user";

export default {

    ADD_ADMIN_PROFILE:                          ADMIN_PROFILE_BASE_URL + "/create",
    LIST_ADMIN_PROFILE:                         ADMIN_PROFILE_BASE_URL + "/list",

    // utils 
    GET_PROFILE_TYPES:                          ADMIN_PROFILE_BASE_URL + "/types",
    GET_ID_TYPES:                               ADMIN_PROFILE_BASE_URL + "/id-types",
    GET_PROFILE_STATUS:                         ADMIN_PROFILE_BASE_URL + "/status",

    // user profile
    GET_PROFILE:                                ADMIN_PROFILE_USER_BASE_URL + "/profile",
    VIEW_PROFILE:                               ADMIN_PROFILE_USER_BASE_URL + "/profile/view",

    // user account
    VIEW_USER_ACCOUNT:                          ADMIN_PROFILE_USER_BASE_URL + "/view"
}